import useSWR from "swr";

interface Subscription {
  id: string;
  membership: {
    name: string;
    imgUrl: string;
  };
  status: "incomplete" | "active" | "pending_cancel" | "canceled";
  cancellationDate: string | null;
  endDate: string | null;
}

interface UseMembershipSubscriptionQueryReturn {
  subscriptions: Subscription[];
  isValidating: boolean;
}

export function useMembershipSubscriptionQuery(
  partnerId: string
): UseMembershipSubscriptionQueryReturn {
  const { data, isValidating } = useSWR(
    `/api/v3/portal/partners/${partnerId}/subscriptions`
  );

  return { subscriptions: data?.data.map(toSubscription) || [], isValidating };
}

function toSubscription(data: any): Subscription {
  return {
    id: data.id,
    membership: {
      name: data.membership.name,
      imgUrl: data.membership.images[0]?.small?.url,
    },
    status: data.status,
    cancellationDate: data.cancelled_date,
    endDate: data.end_date,
  };
}
